import { Component, effect, input, signal } from '@angular/core';
import { ImpactStyle } from '@capacitor/haptics';
import { pulseAnimation } from 'angular-animations';
import { BadgeModule } from 'primeng/badge';
import { HapticsService } from 'haptics.serivce';

@Component({
    selector: 'app-overlay-badge',
    standalone: true,
    templateUrl: './overlay-badge.component.html',
    styleUrls: ['./overlay-badge.component.scss'],
    imports: [BadgeModule],
    animations: [
        pulseAnimation({ anchor: 'pulse', duration: 300, delay: 0 }),
    ],
})
export class OverlayBadgeComponent {
    
    value = input<number>(0);

    pulse = signal(false);

    constructor(private hapticsService: HapticsService) {
        effect(() => {
            const v = this.value();

            if (v > 0) {
                this.pulse.set(true);
                this.hapticsService.impact(ImpactStyle.Light);

                setTimeout(() => {
                    this.pulse.set(false);
                }, 300);
            }
        });
    }
}
